// export const prod = 'https://facade.urboapp.com/urbo-core';
export const prod = 'https://production.urboapp.com/urbo-core';
